export enum TicketType {
    Ticket = 'Ticket',
    Electronic = 'Electronic',
    Paper = 'Paper',
    Mobile = 'Mobile',
    PickupAtVenue = 'PickupAtVenue',
    Lanyard = 'Lanyard',
}
